import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import ChangePasswordModal from './ChangePasswordModal';
import { useAuth } from '../context/AuthContext';

const Layout = () => {
  const { user } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [changePwOpen, setChangePwOpen] = useState(false);

  // Force the modal open whenever the active user must change their password
  useEffect(() => {
    if (user?.must_change_password) setChangePwOpen(true);
  }, [user]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) setMobileOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggle = () => {
    if (isMobile) setMobileOpen(o => !o);
    else setSidebarCollapsed(c => !c);
  };

  const closeMobile = () => setMobileOpen(false);

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Mobile overlay backdrop */}
      {isMobile && mobileOpen && (
        <div
          onClick={closeMobile}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            zIndex: 99, backdropFilter: 'blur(2px)',
          }}
        />
      )}

      <Sidebar
        collapsed={isMobile ? false : sidebarCollapsed}
        mobileOpen={mobileOpen}
        isMobile={isMobile}
        onClose={closeMobile}
      />

      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        marginLeft: isMobile ? 0 : (sidebarCollapsed ? 'var(--sidebar-collapsed)' : 'var(--sidebar-width)'),
        transition: 'margin-left 0.25s ease',
      }}>
        <Header
          onToggleSidebar={handleToggle}
          isMobile={isMobile}
          onChangePassword={() => setChangePwOpen(true)}
        />
        <main style={{
          flex: 1,
          overflowY: 'auto',
          background: 'var(--bg)',
          padding: '0',
          WebkitOverflowScrolling: 'touch',
        }}>
          <Outlet />
        </main>
      </div>

      <ChangePasswordModal
        open={changePwOpen}
        forced={!!user?.must_change_password}
        onClose={() => setChangePwOpen(false)}
      />
    </div>
  );
};

export default Layout;
